import { Component, OnInit } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';
import { UntypedFormBuilder, UntypedFormGroup, Validators, FormArray } from '@angular/forms';
import { TalepService } from 'src/app/services/talep.service';
import { ToastrService } from 'ngx-toastr';
import {
  KayitTurModel,
  UserModel,
} from 'src/app/models/talepAdd2Model';
import { Observable } from 'rxjs';
import { TalepAdd4Model } from 'src/app/models/talepAdd4Model';
import { environment } from 'src/environments/environment';
@Component({
  selector: 'app-talepadd4',
  templateUrl: './talepadd4.component.html',
  styleUrls: ['./talepadd4.component.css'],
})
export class Talepadd4Component implements OnInit {
  form: UntypedFormGroup;
  loading = false;
  dataLoaded = false;
  submitted = false;
  kayitTurModels: KayitTurModel[];
  Users: UserModel[];
  myFiles: string[] = [];
  model: TalepAdd4Model;
  cihazEklenecek = false;
  isCihazZorunlu = false;
  constructor(
    private formBuilder: UntypedFormBuilder,
    private toastrService: ToastrService,
    private router: Router,
    private talepService: TalepService
  ) { }

  ngOnInit() {
    this.isCihazZorunlu = environment.isCihazZorunlu;

    this.GetIsTurList();
    this.form = this.formBuilder.group({
      cihazturid: ['', Validators.required],
      konu: ['', Validators.required],
      sikayet: ['', Validators.required],
      file: ['', null],
      talepedenAdSoyad: ['', Validators.required],
      talepedenCepTel: ['', [Validators.required]],
      cihazEklenecekMi: [this.cihazEklenecek],
      cihazlar: this.formBuilder.array([]),
    });

    if (this.isCihazZorunlu) {
      this.cihazEklenecek = true; // Cihaz alanı açık başlasın
      this.addCihaz();
    }

  }

  get f() {
    return this.form.controls;
  }

  get cihazlar() {
    return this.form.get('cihazlar') as FormArray;
  }

  addCihaz() {
    const cihazForm = this.formBuilder.group({
      marka: ['', null],
      model: ['', null],
      serino: ['', null],
      barkod: ['', null],
    });
    this.cihazlar.push(cihazForm);
  }

  removeCihaz(index: number) {
    this.cihazlar.removeAt(index);
  }

  toggleCihazEkleme() {
    this.cihazEklenecek = this.form.get('cihazEklenecekMi')?.value;
  }

  onFileChange(event: any) {
    for (var i = 0; i < event.target.files.length; i++) {
      this.myFiles.push(event.target.files[i]);
    }
  }

  changeCity(e: any) {
    this.Users = this.kayitTurModels.filter(
      (p) => p.Id == e.target.value
    )[0].Users;
  }

  GetIsTurList() {
    this.talepService.GetIsTurList().subscribe((a) => {


      if (a.BasariliMi) {
        this.kayitTurModels = a.Veri;
      } else {
        this.toastrService.info(a.Mesaj, 'Dikkat');
      }
      this.dataLoaded = true;
    });
  }
  selectedFiles?: FileList;
  currentFile?: File;
  progress = 0;
  message = '';

  fileInfos?: Observable<any>;

  selectFile(event: any): void {
    this.selectedFiles = event.target.files;
  }
  onSubmit() {
    this.submitted = true;

    this.model = Object.assign({}, this.form.value);

    // stop here if form is invalid
    if (this.form.invalid) {
      const invalidFields = Object.keys(this.form.controls).filter(
        (field) => this.form.get(field)?.invalid
      );
      const invalidFieldNames = invalidFields.join(', ');
      this.toastrService.error(
        `Zorunlu alanları doldurun: ${invalidFieldNames}`,
        'Dikkat'
      );
      return;
    }

    if (this.isCihazZorunlu && this.cihazlar.length === 0) {
      this.toastrService.error('Cihaz bilgisi zorunludur.', 'Dikkat');
      return;


    }

    // Marka ve model kontrolü
    for (let i = 0; i < this.cihazlar.length; i++) {
      const cihaz = this.cihazlar.at(i).value;
      if (!cihaz.marka || !cihaz.model) {
        this.toastrService.error(`${i + 1}. Cihaz için marka ve model bilgisi zorunludur.`, 'Dikkat');
        return;
      }
    }

    this.loading = true;

    this.talepService.TalepAdd4Json(this.model, this.myFiles).subscribe(
      (res) => {
        if (res.BasariliMi) {
          this.toastrService.info('Giriş Başarılı', 'Başarılı!');
          this.router.navigateByUrl('/talep');
        } else {
          this.toastrService.error(res.Mesaj, 'Dikkat!1');
          this.loading = false;
        }
      },
      (err) => {
        this.toastrService.error(err.Mesaj, 'Dikkat!2');
        this.loading = false;
      }
    );
  }
}
